module.exports = __webpack_public_path__ + "images/emoji/shell.e8d62fa0e71a67339f68.png";